import { acknowledgeUserIdentityConflict } from '~src/app/actions/spaces/UserIdentityActions';
import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';

import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const AcknowledgeUserIdentityConflictAction: IEntityAction<IUserIdentityConflictInfo, {}> = {
  name: EntityActionNames.AcknowledgeUserIdentityConflict,
  translateName: Messages.identityMigration_AcknowledgeUserIdentityConflict,
  isVisible:  (targetItems: IUserIdentityConflictInfo[], state: AppState) => areAllConflictsNotAcknowledged(targetItems),
  isClickable: (availableActions: {}, targetItems: IUserIdentityConflictInfo[], state: AppState) => areAllConflictsNotAcknowledged(targetItems),
  createReduxAction: (targetItems: IUserIdentityConflictInfo[]) => acknowledgeUserIdentityConflict(targetItems)
};

function areAllConflictsNotAcknowledged(targetItems: IUserIdentityConflictInfo[]): boolean {
  return targetItems.every(x => !x.acknowledged);
}
